
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GearRequest } from '../../../models/gearrequest.model';
import { RolePermissionCheck } from '../../../models/role-permission-check.model';
import { GearRequestService } from '../../../services/gearrequest.service';

@Component({
  selector: 'gear-request-view',
  templateUrl: './gear-request-view.component.html'
})
export class gearRequestViewComponent {
  emsgearRequestObj: GearRequest;
  gearRequestId: number = 0;
  rolePermissionCheckModel: RolePermissionCheck;

  constructor(
    private gearRequest: GearRequestService,
    private route: ActivatedRoute,
    private routerService: Router) {
    this.rolePermissionCheckModel = this.route.snapshot.data['rolePermissions'];
    if (this.rolePermissionCheckModel && this.rolePermissionCheckModel.isRead) {
      this.route.params.subscribe(params => {
        let Id = params['id']
        if (Id != null && Id != undefined) {
          this.gearRequestId = parseInt(Id);
        }
      });
    }
  }

  ngOnInit() {
    if (this.rolePermissionCheckModel && this.rolePermissionCheckModel.isRead) {
      this.emsgearRequestObj = this.initializeCompanyTrainingModel();
      if (this.gearRequestId > 0) {
        this.gearRequest.getGearRequestData('GetGearRequestData', this.gearRequestId).subscribe(res => {
          this.emsgearRequestObj = res;
          console.log(this.emsgearRequestObj);
        });
      }
    }
  }

  initializeCompanyTrainingModel(): GearRequest {
    return {
      comments: null,
      crew: 0,
      email: null,
      endDate: null,
      gearRequestId: 0,
      gearStatus: null,
      gearType: 0,
      helmetPartsCheck: false,
      lastName: null,
      othersCheck: false,
      othersDesc: null,
      reason: null,
      replaceOrRepair: 0,
      requestDate: null,
      requestDateStr: null,
      specificNeed: null,
      startDate:null
    } as GearRequest;

  }

  openCFile(companyTrainingId: string, fileName: string) {
    //this.emsService.getCompanyTrainingFile('GetCompanyTrainingFile', companyTrainingId, "CompanyTraining").subscribe(res => {
    //  saveAs(res, fileName);
    //});
    //return false;
  }

  GoBack(): void {
    this.routerService.navigate(['/gearrequestreport']);
  }

  goHome(): void {
    this.routerService.navigate(['/home']);
  }
}
